import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Content from "./content-section"

export default function CurrentPromotions({ format = "default", }) {
  const data = useStaticQuery(graphql`
    {
        wpPage(id: {eq: "cG9zdDo0MTI="}) {
            customSections {
                sections {
                    ... on WpPage_Customsections_Sections_Content {
                        ...Blocks
                        isPromotions
                    }
                }
            }
        }
        wpOption(id: {eq: "cG9zdDo5OA=="}) {
            promotionsOptions {
                currentPromotions {
                    heading
                    description
                    promotionsPageLink {
                        target
                        title
                        url
                    }
                }
            }
        }
    }
  `)
  const promotions = data?.wpPage?.customSections?.sections?.find(section => section?.isPromotions)
  const firstThreePromotions = promotions?.blocks?.filter(block => block?.display).slice(0, 3)
  const options = data?.wpOption?.promotionsOptions?.currentPromotions

  const contentProps = {
    heading: options?.heading,
    content: options?.description,
    cta: options?.promotionsPageLink,
    blocks: firstThreePromotions,
    // blocksFormat: format === "compact" ? "sliderDark" : "sliderLight",
    blocksFormat: "sliderLight",
    alignment: format === "compact" ? "left" : "center",
    backgroundColor: format === "compact" ? "" : "white",
    collapseBlocksContent: true,
    sliderOverrides: format === "compact" ? {
      slidesToShow: 1,
      slidesToScroll: 1,
      className: `slick-arrows-centered -mx-[1px] ${format === "compact" ? "" : "slick-arrows-wide"}`,
      responsive: null
    } : null,
  }
  return (
    <>
      {firstThreePromotions?.length ?
        <Content props={contentProps} /> : null}
    </>

  )
}